/**
 * @description Creates a proxy for the service object.
 * Allows us to pass the client to the static handlers
 * of the generated api service/sdk.
 * @param client - The client object.
 * @param service - The service object.
 * @returns A proxy for the service object.
 */
export const createProxyService = <T extends object>(client: any, service: T): T => {
    return new Proxy(service, {
        get(target: T, prop: string | symbol) {
            const originalProperty = target[prop as keyof T];
            if (originalProperty instanceof Function) {
                return (...args: any[]) => {
                    // get the runtime options of the static service method
                    const options = args[0] && typeof args[0] === 'object' ? { ...args[0] } : {};
                    // inject the client arg
                    options.client = client;
                    // call the original property with the runtime options and arguments
                    return originalProperty.call(target, options, ...args.slice(1));
                };
            }
            return originalProperty;
        },
    });
};
